import { useSyncExternalStore } from 'react';

export const SKIP_TO_RESULTS_ID = 'results';

const mountedResults = new Set<HTMLElement>();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const notify = () => listeners.forEach((listener) => listener());

const hasResults = () => mountedResults.size > 0;

const trackResults = (node: HTMLElement | null) => {
  if (!node) return;

  mountedResults.add(node);
  notify();

  return () => {
    mountedResults.delete(node);
    notify();
  };
};

export const skipToResultsTarget = {
  id: SKIP_TO_RESULTS_ID,
  ref: trackResults,
};

export const useHasSkipToResultsTarget = () =>
  useSyncExternalStore(subscribe, hasResults, () => false);
